import type { FC } from "react";

import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

import FeatureUpgradeBannerRow from "../FeatureUpgradeBanner/FeatureUpgradeBannerRow";

interface IDomainLimitFeatureUpgradeBannerProps {
    isSubmitted: boolean;
    onSubmit: () => void;
}

export const DomainLimitUpgradeBanner: FC<IDomainLimitFeatureUpgradeBannerProps> = ({ isSubmitted, onSubmit }) => {
    const handleSubmit = () => {
        void requestFeature("Signals Api Domain Limit");
        onSubmit();
    };

    return (
        <FeatureUpgradeBannerRow
            subtitleKey="si.management.hook.domain-limit.text"
            buttonTextKey="hook_modal.contact_us.cta"
            isSubmitted={isSubmitted}
            onSubmit={handleSubmit}
        />
    );
};
